import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getPromptStrength } from '../../../../redux/form/selectors';
import { changePromptStrength } from '../../../../redux/form/actions';
import PanelInputField from '../PanelInputField';
import RangeSlider from '../RangeSlider';
import LabelText from '../LabelText';
const PromptStrengthSliderField = ()=>{
    const { t } = useTranslation('dreamup');
    const strength = useSelector(getPromptStrength);
    const dispatchChangePromptStrength = useAction(changePromptStrength);
    const handleChange = useCallback((e)=>{
        dispatchChangePromptStrength(parseInt(e.target.value));
    }, [
        dispatchChangePromptStrength
    ]);
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "label",
        label: /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.promptStrength.label')),
        input: /*#__PURE__*/ React.createElement(RangeSlider, {
            name: "promptStrength",
            value: strength,
            onChange: handleChange,
            min: 0,
            max: 20,
            step: 1
        })
    });
};
PromptStrengthSliderField.displayName = 'PromptStrengthSliderField';
export default PromptStrengthSliderField;

//# sourceMappingURL=PromptStrengthSliderField.js.map